import { createContext } from "react";

export const ArrayInputContext = createContext<Value>({
  index: NaN
});

interface Value {
  index: number;
}
